import { render, staticRenderFns } from "./GValidationMediator.vue?vue&type=template&id=74314c79&"
import script from "./GValidationMediator.vue?vue&type=script&lang=ts&"
export * from "./GValidationMediator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports